import React from 'react';
import {Alert, Table} from 'react-bootstrap';
import {DataAPI, useData} from '../services/API';
import type {PrinterConsumablesEntry} from '../services/API';
import {CounterCell, Loading} from './Components';

/** Minuty na czytelny zapis - w tabeli częściej widać dni niż minuty */
const formatDuration = (minutes: number) => {
  if (minutes === null || typeof minutes === 'undefined') return '—';
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  if (hours < 24) {
    const rest = minutes % 60;
    return rest ? `${hours} h ${rest} min` : `${hours} h`;
  }
  const days = Math.floor(hours / 24);
  const restHours = hours % 24;
  return restHours ? `${days} d ${restHours} h` : `${days} d`;
}

type Props = {
  printerId: number,
  showHeader?: boolean
}

const PrinterConsumables = ({printerId, showHeader = true}: Props) => {

  const {isLoading, error, data} = useData({printerId}, 'printer-consumables', DataAPI.getPrinterConsumables);

  const body = () => {
    if (isLoading) return <Loading />;
    if (error) return <p>{error.message}</p>;

    const list: PrinterConsumablesEntry[] = (data && data.consumables) || [];
    const range = `ostatnich ${data.months} miesięcy`;
    if (!list.length) return <Alert variant="primary">Brak wymian materiałów z {range}</Alert>;

    return <>
      {/* zakres musi być widoczny też w zakładkach, gdzie nagłówek sekcji jest ukryty */}
      <p className="consumables-range">Dane z {range}</p>
      {data.truncated && (
        <Alert variant="warning">
          Historia urządzenia przekroczyła limit — najstarsze wymiany mogły zostać pominięte.
        </Alert>
      )}
      <Table responsive striped hover>
        <thead>
          <tr>
            <th>Materiał</th>
            <th>Kolor</th>
            <th>Zdarzenie</th>
            <th>Moment wymiany</th>
            <th>Liczniki</th>
            <th>Czas trwania</th>
          </tr>
        </thead>
        <tbody>
          {list.map((row, idx) => <tr key={idx}>
            <td>{row.material}</td>
            <td>{row.color}</td>
            <td>{row.event}</td>
            <td>
              {row.closedAt}
              {row.notes ? <i className="fas fa-info-circle consumables-note" title={row.notes} /> : null}
            </td>
            <td title={row.countersAt ? `Liczniki z odczytu ${row.countersAt}` : undefined}>
              <CounterCell rows={[
                {label: 'Total', value: row.totalCounter},
                {label: 'Mono', value: row.monoCounter},
                {label: 'Kolor', value: row.colorCounter},
              ]}/>
            </td>
            <td>{formatDuration(row.durationMinutes)}</td>
          </tr>)}
        </tbody>
      </Table>
    </>;
  }

  return <div className="settings-section printer-consumables">
    {showHeader ? <h2>Wymiany materiałów</h2> : null}
    {body()}
  </div>;
}

export default PrinterConsumables;
